import _ from 'lodash';
import React, { useContext, useEffect } from 'react';
import {ApplicableTableSettings} from '../../../../tableSettings';

import useTableStorage from '../../../../hooks/useTableStorage';
import {btLocalDODetailInfo} from "../../tableSettings";
import EditableTable, { CellData, TableCellTypes } from "../../../../ui/tables/editing/EditableTable";
import { BtDoDetail } from '../../../../fms.core/BtDoDetail';
import { BtDo } from '../../../../fms.core/BtDo';
import BtOrderLookupField from '../../../../uiControls/lookup/BtOrderLookupField';
import useTableNavigation from '../../../../ui/tables/useTableNavigation';
import SmartTable from '../../../../uiControls/SmartTable';
import { FloatRenderer, TextAlignLeftRenderer, TextRenderer } from '../../../../uiControls/SmartTableRenderers';
import { FormType } from '../../../../fms.enum';
import { NavigationType, openNewPage } from '../../../../util/navigationHelpers';
import { useHistory } from 'react-router';

interface ICntrListItem extends BtDoDetail {
  changeLineItem: (change:Partial<ICntrListItem>, index: number) => boolean,
  addLineItem: () => void,
  deleteRow: (index: number) => Promise<void>,
  isView:boolean,
  searchOrderId: string,
}

interface DetailOrderRendererParam {
  data:ICntrListItem[],
  row: any
}

function IndicatorRenderer({row}: any) {
  return <div style={{paddingTop: '2px', textAlign: 'center', width: '100%'}}>{row.index + 1}</div>;
}

function OrderNoRenderer({ data, row }:DetailOrderRendererParam) { 
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  const searchOrderId = data[0].searchOrderId;

  return (
    <BtOrderLookupField
      lookupId={`btDoDetail-orderNo-${row.index}`}
      initialValue={l.orderNo}
      searchId={searchOrderId} // Edit, View 모드로 열었을 때 해당 데이터의 Order가 Lookup에 표시하기 위해 추가
      disabled={l.isView}
      maxLength={20}
      type='BTD'
      onTextChange={orderNo => changeLineItem({ orderNo, orderId: 0 }, row.index)}
      onSelect={order => { 
        return changeLineItem({ 
          orderNo: order.orderNo,
          orderId: order.id,
          destPort: order.destPort,
          pkgs: order.pkgs,
          punit: order.punit,
          kgs: order.kgs,
          lbs: order.lbs,
          cft: order.cft,
          cbm: order.cbm,
          puLoc: order.pickupLocId,
          puLocName: order.pickupLoc,
          deliverTo: order.destId,
          deliverToName: order.destination,
          refNo: order.custRefNo,
          trailer: order.containerNo,
          origin: order.originId,
          originName: order.origin,

        }, row.index);
      }} 
      focusElementAfterSelect={(data:any) => {
        if(data){
          return  document.getElementById(`btDoDetail-orderNo-${row.index}`) as HTMLInputElement;
        }else{
          return null;
        }
      }}
    />
  );
}


function BTLocalDODetailInfo({ btDo, onChange, isView, tableName, selectedIndex, setSelectedIndex, mode
}:{
  btDo: BtDo, 
  onChange:((x: Partial<BtDo>) => void) | undefined
  isView:boolean,
  tableName: string,
  selectedIndex?:number,
  setSelectedIndex?:(x: number) => void
  mode?: FormType}){

  const tableStorage = useTableStorage();
  const history = useHistory(); 
  
  const { selectTableRow } = useTableNavigation("btLocalDODetailInfoView", null, null, [], false, false, false);
  
  useEffect(() => {
    if(selectedIndex !== undefined && selectedIndex > -1){
      selectTableRow(selectedIndex ?? 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedIndex]);

  async function deleteRow(index:number) {
    const loadOrderList = btDo.loadOrderList;

    if (!loadOrderList) {
      return false;
    }
    if (isView) {
      return false;
    }
    
    loadOrderList.splice(index, 1);

    if(onChange) onChange({loadOrderList});
    return true;
  }

  function addLineItem() {

    const newOrder = new BtDoDetail({ doId: btDo.id });
    newOrder.trackable = true;
    return {
      setDataFunc: (list: any) => {if(onChange) onChange({ loadOrderList: list })},
      curListData: btDo.loadOrderList,
      newData: newOrder
    }
  }


  function changeLineItem(change: Partial<ICntrListItem>, index:number) {
    if(!btDo.loadOrderList){
      return false;
    }
    let temp = null;
    if(!change.orderId){
      change.orderNo = '';
      change.destPort = '';
      change.pkgs = 0;
      change.punit = '';
      change.cft = 0;
      change.kgs = 0;
      change.cbm = 0;
      change.lbs = 0;
    } else 
    if (change.orderId> 0 && change.orderNo){
      if(btDo.loadOrderList.some(x => x.orderNo === change.orderNo && x.id != btDo.loadOrderList[index].id)){
        change.orderId = 0;
        change.orderNo = '';
        change.destPort = '';
        change.pkgs = 0;
        change.punit = '';
        change.cft = 0;
        change.kgs = 0;
        change.cbm = 0;
        change.lbs = 0;

        temp = 'Duplicate PRO #';
      }
    }
    btDo.loadOrderList[index] = _.merge(btDo.loadOrderList[index], change);
    if(onChange) onChange({loadOrderList: btDo.loadOrderList});
    if(mode && mode === FormType.ModeAdd && index === 0){
      if(onChange && change.orderId){
        onChange({
          puLoc: change.puLoc ? change.puLoc : change.origin,
          puLocName:change.puLoc ? change.puLocName: change.originName,
          refNo: change.refNo,
          deliverTo: change.puLoc ? change.origin: change.deliverTo,
          deliverToName: change.puLoc ? change.originName: change.deliverToName,
          trailer: change.trailer,
        })
      }
    } else if (mode && mode === FormType.ModeEdit && index === 0){
      if(onChange && change.orderId){
        if(!btDo.puLoc) onChange({puLoc: change.puLoc ? change.puLoc : change.origin, puLocName:change.puLoc ? change.puLocName: change.originName})
        if(!btDo.deliverTo) onChange({ deliverTo: change.puLoc ? change.origin: change.deliverTo, deliverToName: change.puLoc ? change.originName: change.deliverToName})
        if(!btDo.refNo) onChange({refNo: change.refNo});
        if(!btDo.trailer) onChange({ trailer: change.trailer});
      }
    }

    return temp;
  }

    const orderNoHasLink = (l: BtDoDetail) => l.orderId > 0 && !_.isEmpty(l.orderNo);
  
    async function openOrderLink(index: number) {
      const l = btDo.loadOrderList[index];
      const hasLink = l.orderId > 0 && !_.isEmpty(l.orderNo);
    
      if (!hasLink) return;
      
      openNewPage(history, `/brokerageTrucking/order/view/${l.orderId}`, NavigationType.newPage);
    }

  const editTableOptions:ApplicableTableSettings = {
    tableName: tableName,
    ...btLocalDODetailInfo,
    height: '359px',
    data: btDo.loadOrderList.map((x, i) => ({...x, i, changeLineItem, addLineItem, deleteRow, isView,  searchOrderId:btDo.searchOrderId, puLoc: btDo.puLoc })),
    showNewRowPlaceholder: false,
    useEditControls: !isView,
    rowRenderers: [
      { accessor: 'indicator'},
      { accessor: 'destPort' },
      { accessor: 'orderNo', EditCell: OrderNoRenderer },
      { accessor: 'pkgs',},
      { accessor: 'punit'},
      { accessor: 'lbs'},
      { accessor: 'cft' },
      { accessor: 'kgs'},
      { accessor: 'cbm' },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      const curRowData = rowData as BtDoDetail;
      if(accessor === 'indicator'){
        const cellProps: { type: TableCellTypes; value: string; onLabelClick?: () => void, tooltip?: string } = {
          type: TableCellTypes.Null,
          value: ''
        };
        if (orderNoHasLink(curRowData)) {
          cellProps.onLabelClick = () => { openOrderLink(rowIndex) };
          cellProps.tooltip = "Switch to Manifest";

        }
        return cellProps;
      }
      if(accessor === 'destPort')
        return { type: TableCellTypes.Text, value: curRowData.destPort };
      else if (accessor === 'orderNo')
        return { type: TableCellTypes.Text, value: curRowData.orderNo };
      else if (accessor === 'pkgs')
        return { type: TableCellTypes.Number, value: curRowData.pkgs, decimal: 0 };
      else if (accessor === 'punit')
        return { type: TableCellTypes.Text, value: curRowData.punit };
      else if (accessor === 'lbs')
        return { type: TableCellTypes.Number, value: curRowData.lbs, decimal: 0};
      else if (accessor === 'cft')
        return { type: TableCellTypes.Number, value: curRowData.cft, decimal: 0 };
      else if (accessor === 'kgs')
        return { type: TableCellTypes.Number, value: curRowData.kgs, decimal: 0 };
      else if (accessor === 'cbm')
        return { type: TableCellTypes.Number, value: curRowData.cbm, decimal: 3 };
      else
        return undefined;
    },
    isCellLock: (accessor: string): boolean => {
      if(isView) return true;
      if (accessor === 'destPort' || accessor === 'pkgs' || accessor === 'punit'|| accessor === 'lbs' || accessor === 'cft' || accessor === 'kgs' || accessor === 'cbm')
        return true;

      return false;
    },
    onNewRow: addLineItem,
    customStorage: tableStorage,
    footerRow: [
    ],
  };

  const noEditTableOptions:ApplicableTableSettings = {
    tableName: tableName,
    ...btLocalDODetailInfo,
    data: btDo.loadOrderList.filter(x => x.orderId > 0).map((x, i) => ({...x, i, changeLineItem, addLineItem, deleteRow, isView,  searchOrderId:btDo.searchOrderId, puLoc: btDo.puLoc })),
    showNewRowPlaceholder: false,
    useEditControls: !isView,
    rowRenderers: [
      { accessor: 'indicator', Cell: IndicatorRenderer},
      { accessor: 'destPort', Cell: TextRenderer },
      { accessor: 'orderNo', Cell: TextAlignLeftRenderer },
      { accessor: 'pkgs', Cell: (props:any) => <FloatRenderer decimals={0} {...props} />},
      { accessor: 'punit', Cell: TextAlignLeftRenderer},
      { accessor: 'lbs', Cell: (props:any) => <FloatRenderer decimals={0} {...props} />},
      { accessor: 'cft', Cell: (props:any) => <FloatRenderer decimals={0} {...props} />},
      { accessor: 'kgs', Cell: (props:any) => <FloatRenderer decimals={0} {...props} />},
      { accessor: 'cbm', Cell: (props:any) => <FloatRenderer decimals={3} {...props} />},
    ],
    rowProps: (row: any) => ({
      onClick: () => {
          if(setSelectedIndex) setSelectedIndex(row.index);
      }
    }),
  };

  return (
    <div style={{width: '800px'}}>
      {tableName !== "btLocalDODetailInfoView" ?
        <EditableTable
          showBottomBtn={false}
          tableOptions={editTableOptions}
          deleteLine={deleteRow}
          addLine={addLineItem}
        />
        : <SmartTable {...noEditTableOptions} /> 
      }

    </div>
  );
}

export default React.memo(BTLocalDODetailInfo);
